import React, {useEffect} from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {Link} from "../link/link";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ACTION_TYPES} from "../../consts";
import {BreadcrumbsArrow} from "./breadcrumbs.arrow";
import styles from "./breadcrumbs.module.scss";
import classNames from "classnames";

class BreadcrumbsItemProps extends BaseProps {}

export const BreadcrumbsItem = ({controller, item, isLast, isCollapsed, onRenderComplete}: BreadcrumbsItemProps) => {
  const isClickable: Boolean = !(isLast && !isCollapsed);
  const model: BaseLinkModel = isClickable ? item.model : null;

  const itemProps = {
    model: model,
    className: classNames(styles.item, {[styles.item_collapsed]: isCollapsed}, {[styles.last_item]: isLast && !isCollapsed}),
    onClick: () => isClickable && controller.action(ACTION_TYPES.onBreadcrumbsClick, {
      position: item.position,
      entityId: item.entityId,
      entityType: item.entityType,
    })
  }

  useEffect(() => {
    isLast && onRenderComplete && onRenderComplete()
  }, [])

  return (
    <Link {...itemProps}>
      {item.name}
      {
        !isLast && !isCollapsed ? <BreadcrumbsArrow controller={controller}/> : null
      }
    </Link>
  )
};
